import {BaseCachedService} from './Core/BaseCachedService';
import {BaseService} from "./Core/BaseService";

class OfflineDataService extends BaseCachedService {
    get Url() { return super.Url + "/offlineData"; }

    Download(hierarchyId = null, projectId = null, sampleEventId = null, includeAllPhotos = undefined) {
        const request = {hierarchyId, projectId, sampleEventId, includeAllPhotos};
        return this.SendRequest(BaseService.POST, request, null, '/download');
    }
}

export const service = new OfflineDataService();

